import { useState } from 'react';
import { useSelector } from 'react-redux';

import bullhornSvg from 'assets/icons/bullhorn.svg';
import selectListSvg from 'assets/icons/select_list.svg';
import Button, { Color, Size } from 'lib/Button';

import DealViewToggle from 'components/common/Deal/DealViewToggle';
import DealInfo from './DealInfo';
import DealLineInfo from './DealLineInfo';

const RightSidebar = () => {
  const [activeTab, setActiveTab] = useState(2);
  const dealName = useSelector((state) => state.dealManagement.commonDeal.dealName);
  const name = useSelector((state) => state.dealManagement.commonDeal.currentLine.name);

  const tabs = [
    {
      id: 1,
      icon: bullhornSvg,
      content: <DealInfo />,
      title: dealName,
    },
    {
      id: 2,
      icon: selectListSvg,
      content: <DealLineInfo />,
      title: name,
    },
  ];
  const selectedTab = tabs.find((tab) => tab.id === activeTab);

  return (
    <div
      data-test-id="deal-availability"
      className="pt-4 px-5 overflow-x-hidden h-full relative w-[var(--right-sidebar-width)]"
    >
      <div className="mb-3 empty:hidden">
        <DealViewToggle />
      </div>
      <div className="flex items-center justify-between mb-[12px]">
        <p
          className="body-base text-neutral-900 whitespace-nowrap overflow-hidden overflow-ellipsis"
          title={selectedTab.title}
          data-test-id="right-sidebar-title"
        >
          {selectedTab.title}
        </p>
        <div className="flex justify-end items-center" data-test-id="right-sidebar-switch">
          {tabs.map((tab) =>
            tab.isHidden ? null : (
              <Button
                key={tab.id}
                ariaLabel={`${tab.title}`}
                onClick={() => setActiveTab(tab.id)}
                color={Color.BLACK_AND_WHITE}
                size={Size.SMALL}
                svg={tab.icon}
                classNames={activeTab === tab.id ? 'text-primary' : 'text-neutral'}
              />
            ),
          )}
        </div>
      </div>
      {selectedTab?.content}
    </div>
  );
};

export default RightSidebar;
